<div class="batch-partial-notification">
  <div class="batch-partial-notification-text">
    <div class="batch-partial-notification-text-header">{{ header | translate }}</div>
    <div class="batch-partial-notification-text-hint">{{ hint | translate }}</div>
  </div>
</div>
